import { createSelector } from 'reselect'

import type { StoreState } from '~/store/store'
import { useStore } from '~/store/store'

import { type Department } from '../'

export type ActiveDepartment = Department | 'Alle'

export const selectActiveDepartment = createSelector(
    (state: StoreState) => state.appFilters.departmentKey,
    (state: StoreState) => state.di.entities.departments.byId,
    (departmentKey, byId): ActiveDepartment | undefined => {
        if (departmentKey === 'all') return 'Alle'
        return byId[departmentKey]
    }
)

export const selectDepartmentBySpecialityId = createSelector(
    (state: StoreState) => state.di.entities.specialities.byId,
    (state: StoreState) => state.di.entities.departments.byUuid,
    (_, specialityId: number) => specialityId,
    (specialitiesById, departmentsByUuid, specialityId): Department | undefined => {
        const speciality = specialitiesById[specialityId]
        if (!speciality?.department_uuid) return undefined
        return departmentsByUuid[speciality.department_uuid]
    }
)

export function useActiveDepartment() {
    return useStore(selectActiveDepartment)
}
